import {useContext, useEffect, useState} from "react";
import {AI, boxType} from "../component/const";
import TopBar from "../component/TopBar";
import {CheckboxInput} from "../component/CheckboxInput";
import {Context} from "../component/context";

export const Prompt = () => {

    const {meta, setMeta, problems, setProblems, path} = useContext(Context);

    useEffect(() => {
        if (path !== 'prompt') return
        setMeta({
            ai: [AI[0]],
            questions: 1,
        })
    }, [path]);

    const [type, setType] = useState({})
    const [count, setCount] = useState({})

    const addStep = () => {
        const index = (Object.keys(problems).length + 1).toString()
        const key = `step${index}`
        setType(prev => ({
            ...prev,
            [key]: boxType[0].key
        }))
        setCount(prev => ({
            ...prev,
            [key]: -1
        }))
        setProblems(prev => ({
            ...prev,
            [key]: {label: `${index}단계`, title: '', options: []}
        }))
    }

    const addOption = (key) => {
        let toPush = {
            title: "",
            type: type[key]
        };
        switch (type[key]) {
            case boxType[0].key:
                alert("형태를 선택해주세요!")
                return
            case boxType[1].key:
            case boxType[2].key:
                if (count[key] === -1) {
                    alert("갯수를 선택해주세요!")
                    return;
                } else {
                    const selection = []
                    selection.push("")
                    selection.push("")
                    for (let i = 0; i < count[key]; i++) {
                        selection.push("")
                    }
                    toPush = {
                        ...toPush,
                        selection: selection,
                    }
                }
                break
            case boxType[3].key:
                toPush = {
                    ...toPush,
                    input: ""
                }
                break
            case boxType[4].key:
                toPush = {
                    ...toPush,
                    value: ""
                }
                break
            default:
                alert("버그가 난 것 같습니다. 개발자에게 문의해주세요.")
                return
        }
        const list = {...problems}
        list[key].options.push(toPush)
        setProblems(list)
    }

    const onChange = (value, toChange) => {
        setMeta(prev => ({
            ...prev,
            [toChange]: toChange === 'questions' ? isNaN(parseInt(value)) ? '' : parseInt(value) : value
        }))
    }

    const changeAi = (value, toChange, adding) => {
        const trans = [...meta.ai]
        const ai = "ai"
        if (adding) {
            if (trans.length === 4) alert("최대 4개만 선택 가능합니다.")
            else if (!Array.isArray(trans)) onChange([value], ai)
            else {
                trans.push(value)
                onChange(trans, ai)
            }
        } else onChange(trans.filter(it => it !== value), ai)
    }

    return <div className='w-full  h-screen overflow-x-scroll hidden templates' id='prompt'>
        <table className="overflow-x-auto [&_tr]: my-4">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-4 py-4 border text-xl">사용 가능 AI</th>
                <th className="px-4 py-4 border text-xl">검색 허용 횟수</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="px-4 py-4 border text-xl">
                    {AI.map((it, index) =>
                        (<CheckboxInput
                            key={`${index}${it}qwfenop`} index={index} metaData={meta}
                            toChange="ai" label={it} onChange={changeAi}/>))}
                </td>
                <td className="px-4 py-4 border text-xl">
                    <input value={meta.questions} className='p-2 border-solid border-2 rounded'
                           onChange={(e) => onChange(e.target.value, 'questions')}/></td>
            </tr>
            </tbody>
        </table>
        <TopBar add={addStep} title='프롬프트'/>
        {Object.keys(problems).map(key => (<>
            <TopBar key={key} step={key} title={problems[key].label} value={type}
                    setValue={setType} count={count} setCount={setCount} add={addOption}/>
            {/*<div className="questionHolder">*/}
            {/*    <input placeholder="단계 설명글을 입력해주세요." value={question[key].title}*/}
            {/*        onChange={(e) => onChangeTitle(e.target.value, key)}/>*/}
            {/*</div>*/}
            {problems[key].options?.map((it, subject) => (<section key={key + "section"} className='section'>
                <div className="titleHolder">
                    <input placeholder="주제 입력" key={`${key}${subject}prompt`}
                           className={`inputBorder inputTextAreaMargin`}
                           disabled style={{width: "calc(100% - 20px"}}/>
                </div>
                <div className="contentsHolder">
                    {it.hasOwnProperty('selection') ? it.selection.map((item, selection) => (<>
                            <img src={it.type === boxType[1].key ? "/images/radio.svg" : "/images/select.svg"}/>
                            <input className={"inputBorder inputTextAreaMargin"} key={`${subject}promptnewjw`}
                                   placeholder="보기 입력" disabled/>
                        </>)) :
                        it.hasOwnProperty('input') ?
                            <input key={`${subject}prompthasownpropinput`}
                                   className={"inputBorder !m-0"} value={it.value}
                                   placeholder={'모범 문장 입력'} disabled/> :
                            <textarea className={"inputBorder inputTextAreaMargin"} value={it.value}
                                      placeholder={'예시 문단 입력'} disabled/>}
                </div>
            </section>))}
        </>))}
    </div>
}